import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  listUrl = urlServer.concat('/v1/admin')

  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");
  }
  constructor(private http: HttpClient) { }

  getAccounts(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.http.get<ServiceResponse>(this.listUrl,{headers: header});
  }

}
